export enum Icon {
  Chevron = 'chevron',
  ChevronBold = 'chevron-bold',
  Cross = 'cross',
  Warning = 'warning',
  CircleArrow = 'circle-arrow',
  Plus = 'plus',
  PlusCircle = 'plus-circle',
  Contrast = 'contrast',
  Print = 'print',
  Copy = 'copy',
  Trash = 'trash',
  Info = 'info',
  CheckCircle = 'check-circle',
}
